const theme = {
  color: {
    text: '#414141',
    action: '#00698F',
    focus: '#9163DE',
    muted: '#626262',
    border: '#808080',
    bgShade: '#F5F5F5',
    bgAlt: '#EBEBEB',
    bgAltShade: '#E0E0E0',
    error: '#D60000',
    success: '#0B996C',
    white: '#FFFFFF',
    black: '#313131',
    boxShadow: '#C0C0C0',
    btnText: '#00698f',
    bgAlert: '#0b996c',
  },
}

export default theme
